/**
 * エントリポイント：タブ切替・状態購読・Service Worker登録。
 */
import {
  activeArea,
  maybeSwitchArea,
  subscribe,
  loadPersisted,
  state,
  rolloverIfNeeded,
} from "./state.js";
import { maybeAutoStart, watchVisibility } from "./session.js";
import { ensureTerrain } from "./terrainService.js";
import { renderHome } from "./views/home.js";
import { renderProducts } from "./views/products.js";
import { renderMap, destroyMap } from "./views/map.js";
import { renderMonthly } from "./views/monthly.js";
import { renderCare, destroyCare } from "./views/care.js";
import { renderSettings } from "./views/settings.js";

type Tab = "home" | "map" | "products" | "monthly" | "care" | "settings";
let activeTab: Tab = "home";

const view = document.getElementById("view")!;
const banner = document.getElementById("banner")!;
const badge = document.getElementById("status-badge")!;

function render(): void {
  badge.textContent = state.sessionActive
    ? state.degraded
      ? "計測中（晴天仮定）"
      : "計測中"
    : "";
  switch (activeTab) {
    case "home":
      renderHome(view);
      break;
    case "map":
      renderMap(view);
      break;
    case "products":
      renderProducts(view);
      break;
    case "monthly":
      void renderMonthly(view);
      break;
    case "care":
      void renderCare(view);
      break;
    case "settings":
      renderSettings(view);
      break;
  }
}

for (const btn of document.querySelectorAll<HTMLButtonElement>("#tabbar button")) {
  btn.onclick = () => {
    document.querySelectorAll("#tabbar button").forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");
    if (activeTab === "map") destroyMap();
    if (activeTab === "care") destroyCare(); // カメラを止める
    activeTab = btn.dataset.tab as Tab;
    view.innerHTML = "";
    render();
  };
}

subscribe(render);
watchVisibility(banner);

async function boot(): Promise<void> {
  await loadPersisted();
  await rolloverIfNeeded(Date.now());
  // 前回の測位が別エリアなら、描画前に切り替えておく（東京固定を避ける）
  if (state.engine.lastFix) await maybeSwitchArea(state.engine.lastFix);
  await ensureTerrain(state.settings.heightMode, activeArea().id);
  render();
  if ("serviceWorker" in navigator) {
    // 新しいService Workerが有効になったら1回だけ再読込する。
    // これが無いと、更新後もページ自体は旧SWのキャッシュで描かれたままになり、
    // 「直したのに画面が変わらない」が起きる（実際に起きた）。
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      location.reload();
    });
    navigator.serviceWorker.register("./sw.js").catch(() => {});
  }
  // 自動外出モード：起動時に自宅から離れていれば計測開始（§7.2の前景制約内）
  void maybeAutoStart(banner);
}

void boot();
